<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="filter"></ng-container>
            <ng-container *ngTemplateOutlet="buttons"></ng-container>
        </tt-card>

        <ng-container *ngTemplateOutlet="list"></ng-container>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <div class="col-xs-12 sp-0">
            <tt-card class="col-xs-12 col-md-4 p-5">
                <ng-container *ngTemplateOutlet="filter"></ng-container>
            </tt-card>

            <tt-card class="col-xs-12 col-md-2 p-5">
                <ng-container *ngTemplateOutlet="buttons"></ng-container>
            </tt-card>
        </div>

        <div class="col-xs-12 col-md-6 p-5">
            <ng-container *ngTemplateOutlet="list"></ng-container>
        </div>
    </div>
</tt-page>

<ng-template #filter>
    <ng-container *ngIf="!!setting">
        <tt-input ttLabel="searchtext" ttFocus="true" [(ttModel)]="setting.searchtext" ttShowClearButton></tt-input>
    </ng-container>
</ng-template>

<ng-template #buttons>
    <ng-container *ngIf="!!setting">
        <tt-button-goto [ttText]="'serviceobjecttypes_new'" (ttClick)="goToFunc('serviceobjecttype')" ttIcon="fa fa-solid fa-plus"></tt-button-goto>
    </ng-container>
</ng-template>

<ng-template #list>
    <ng-container *ngIf="!!setting">
        <tt-list [ttData]="itemsListTypes" [ttFilter]="setting.searchtext"></tt-list>
    </ng-container>
</ng-template>

<!--<tt-page class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 col-md-6 sp-0">
        <tt-input-buttons class="col-xs-12 sp-0" tt-label="searchtext" tt-focus="false" tt-model="vm.model.settingTypes.searchtext" tt-change="vm.model.settingTypes.searchtext = $value" tt-placeholder="" tt-buttons="vm.model.searchTextButtons"></tt-input-buttons>
        <tt-button class="col-xs-12 sp-0" tt-text="serviceobjecttypes_new" tt-click="vm.goToFunc('serviceobjecttype')" tt-text-align="left" tt-icon="fa fa-solid fa-plus" tt-icon-pull-right="true"></tt-button>
    </tt-card>
    <tt-list class="col-xs-12 col-md-6 sp-0" list-items="vm.model.itemsListTypes" badge="" ltype="" design-var="s12t0" filter-val="vm.model.settingTypes.searchtext"></tt-list>
</tt-page>-->
